import { useState } from "react";
import { Form, Input, InputNumber, Row, Select, Switch } from "antd";
import type { FormInstance, Rule } from "antd/es/form";
import hrnUtils from "../../../utils/hrnUtils";

const AccountForm = ({
  mode,
  accountForm,
  groups,
  ledgerTypes,
}: {
  mode: string;
  accountForm: FormInstance;
  groups: any[],
  ledgerTypes: any[]
}) => {
  const requiredRule: Rule = { required: true, message: "Required" };
  const [isGroup, setIsGroup] = useState<boolean>(accountForm.getFieldValue("isGroup"));
  const [ledgerTypeId, setLedgerTypeId] = useState(accountForm.getFieldValue("ledgerTypeId"));
  return (
    <div className="mb-5" style={{ maxHeight: "70vh", overflowY: "auto", scrollbarWidth: "thin" }}>
      <Form.Item name="accountTitle" label={<>Account Title<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
        <Input placeholder={"Account title"} maxLength={30} />
      </Form.Item>
      <Form.Item name="nature" label={"Nature"} style={{ display: "none" }}>
        <Select options={[{ label: "Dr", value: 1 }, { label: "Cr", value: -1 }]} />
      </Form.Item>
      <Form.Item name="parentId" label={"Parent"}>
        <Select
          style={{ width: "100%" }}
          placeholder={"Select parent account"}
          options={groups.map((x: any) => ({ label: x.accountTitle, value: x.id }))}
          allowClear
          showSearch
          filterOption={(input, option) =>
            ((option?.label?.toLowerCase() as string) ?? "").includes(input.toLowerCase())
          }
        />
      </Form.Item>
      <Row className="gap-[2%]">
        <Form.Item name="status" label={"Status"} className="w-[49%]" initialValue="Active">
          <Select
            style={{ width: "100%" }}
            placeholder={"Select status"}
            options={["Active", "Inactive"].map(x => ({ label: x, value: x }))}
            allowClear
          />
        </Form.Item>
        <div className="flex justify-between w-[49%]">
          <div className="w-[100%] mt-2">
            <div className="form-title">
              {"Category"}
            </div>
            <div className="switch-extra mt-2">
              <label className="float-left">{isGroup ? "Account Group" : "Account"}</label>
              <Form.Item name="isGroup" valuePropName="checked" initialValue={false} className="float-right" style={{ marginBottom: 0 }}>
                <Switch
                  checked={isGroup}
                  onChange={(checked: boolean) => {
                    setIsGroup(checked);
                  }}
                />
              </Form.Item>
            </div>
          </div>
        </div>
      </Row>
      {!isGroup && <Row className="gap-[2%]">
        <Form.Item name="openingBalance" label={"Opening Balance"} className="w-[49%]" initialValue={0}>
          <InputNumber type="number" inputMode="decimal" onKeyPress={(e) => hrnUtils.handleNumberFieldKeyPressEvent(e, { decimal: true })} style={{ width: "100%" }} placeholder={"Opening balance"} />
        </Form.Item>
        <Form.Item name="currentBalance" label={"Current Balance"} className="w-[49%]">
          <InputNumber type="number" inputMode="decimal" disabled onKeyPress={(e) => hrnUtils.handleNumberFieldKeyPressEvent(e, { decimal: true })} style={{ width: "100%" }} placeholder={"Opening balance"} />
        </Form.Item>
      </Row>}
      <Form.Item name="ledgerTypeId" label={"Ledger Type"} initialValue={1} >
        <Select
          style={{ width: "100%" }}
          placeholder={"Select ledger type"}
          options={ledgerTypes.map((x: any) => ({ label: x.name, value: x.id }))}
          onChange={(value) => setLedgerTypeId(value)}
        />
      </Form.Item>
      {(ledgerTypeId === 2 || ledgerTypeId === 3) && <>
        <Row className="gap-[2%]">
          <Form.Item name={["config", "contactPerson"]} label={"Contact Person"} initialValue="" className="w-[49%]">
            <Input placeholder={"Contact person"} />
          </Form.Item>
          <Form.Item name={["config", "email"]} label={"Email"} initialValue="" className="w-[49%]">
            <Input placeholder={"Email"} />
          </Form.Item>
        </Row>
        <Row className="gap-[2%]">
          <Form.Item name={["config", "phone"]} label={"Phone"} initialValue="" className="w-[49%]">
            <Input placeholder={"Phone"} />
          </Form.Item>
          <Form.Item name={["config", "fax"]} label={"Fax"} initialValue="" className="w-[49%]">
            <Input placeholder={"Fax"} />
          </Form.Item>
        </Row>
        <Form.Item name={["config", "address"]} label={"Address"} initialValue="">
          <Input placeholder={"Address"} />
        </Form.Item>
        <Form.Item name={["config", "businessType"]} label={"Business Type"} initialValue="">
          <Input placeholder={"Business type"} />
        </Form.Item>
        <Row className="gap-[2%]">
          <Form.Item name={["config", "country"]} label={"Country"} initialValue="" className="w-[49%]">
            <Input placeholder={"Country"} />
          </Form.Item>
          <Form.Item name={["config", "currency"]} label={"Currency"} initialValue="" className="w-[49%]">
            <Input placeholder={"Currency"} />
          </Form.Item>
        </Row>
      </>}
      {(ledgerTypeId === 4) && <>
        <Form.Item name={["config", "bankName"]} label={"Bank Name"} initialValue="">
          <Input placeholder={"Bank name"} />
        </Form.Item>
        <Row className="gap-[2%]">
          <Form.Item name={["config", "branchName"]} label={"Branch Name"} initialValue="" className="w-[49%]">
            <Input placeholder={"Branch name"} />
          </Form.Item>
          <Form.Item name={["config", "bankAccountType"]} label={"Account Type"} initialValue="" className="w-[49%]">
            <Input placeholder={"Account type"} />
          </Form.Item>
        </Row>
      </>}
      <Form.Item name={["config", "note"]} label={"Note"} initialValue="">
        <Input placeholder={"Note"} />
      </Form.Item>
    </div>
  );
};

export default AccountForm;
